(function () {
  'use strict';

  function initMarquee(root) {
    if (!root || root.dataset.marqueeReady === 'true') return;

    const track = root.querySelector('[data-marquee-track]');
    if (!track) return;

    const viewport = root.querySelector('.marquee__viewport') || track.parentElement || root;

    root.dataset.marqueeReady = 'true';

    let speed = parseFloat(root.dataset.speed);
    if (!speed || speed <= 0) speed = 22;

    let lastSetWidth = 0;
    let measureTimer = null;

    function getTrackGap() {
      const cs = window.getComputedStyle(track);
      const gap = parseFloat(cs.columnGap || cs.gap || '0');
      return isNaN(gap) ? 0 : gap;
    }

    function ensureFilled() {
      const firstGroup = track.querySelector('[data-marquee-group]');
      if (!firstGroup) return;

      const viewportWidth = viewport.clientWidth || root.clientWidth || 0;
      const groupWidth = firstGroup.getBoundingClientRect().width;
      if (groupWidth <= 0) return;

      let safety = 0;
      while (track.scrollWidth < viewportWidth + groupWidth + 1 && safety < 30) {
        const clone = firstGroup.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
        safety++;
      }
    }

    function measure() {
      measureTimer = null;
      ensureFilled();

      const firstGroup = track.querySelector('[data-marquee-group]');
      if (!firstGroup) return;

      const oneSetWidth = firstGroup.getBoundingClientRect().width + getTrackGap();
      if (oneSetWidth <= 0 || Math.abs(oneSetWidth - lastSetWidth) < 0.5) return;
      lastSetWidth = oneSetWidth;

      track.style.setProperty('--marquee-distance', -oneSetWidth + 'px');
      track.style.setProperty('--marquee-duration', speed + 's');
      root.classList.add('marquee--js');
    }

    function scheduleMeasure() {
      if (measureTimer) window.clearTimeout(measureTimer);
      measureTimer = window.setTimeout(measure, 150);
    }

    measure();

    track.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) {
        img.addEventListener('load', scheduleMeasure, { once: true });
        img.addEventListener('error', scheduleMeasure, { once: true });
      }
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleMeasure).catch(function () {});
    }

    window.addEventListener('resize', scheduleMeasure);
  }

  function initAll(scope) {
    const container = scope || document;
    const marquees = container.querySelectorAll('[data-marquee]');
    marquees.forEach(initMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
